import React from 'react';
import MaxCreditLimitDetailsWidget from './max-credit-limit/MaxCreditLimitDetailsWidget';
import { IBusinessPartnerTabProps } from '../..';
import AssignedLinesWidget from './assigned-lines/AssignedLinesWidget';
import AssignedPlansWidget from './assigned-plans/AssignedPlansWidget';
import { useTabsLayoutStyles } from '@styles/sharedStyles';
import { useResetKey } from '@hooks/useResetKey';

const CommissionAndLimitsTab: React.FC<IBusinessPartnerTabProps> = ({
  generalData,
  businessPartnerDetails,
  onSuccess,
}) => {
  const { classes } = useTabsLayoutStyles();

  const [assignedPlansTableKey, refreshPlansTable] = useResetKey(
    'assignedPlansTableKey'
  );

  return (
    <div className={classes.tabContents}>
      <MaxCreditLimitDetailsWidget
        businessPartnerDetails={businessPartnerDetails}
        generalData={generalData}
        onSuccess={onSuccess}
      />
      <AssignedLinesWidget
        generalData={generalData}
        onSuccess={() => {
          onSuccess();
          refreshPlansTable();
        }}
      />
      <AssignedPlansWidget
        generalData={generalData}
        onSuccess={refreshPlansTable}
        tableKey={assignedPlansTableKey}
      />
    </div>
  );
};

export default CommissionAndLimitsTab;
